export default "__VITE_ASSET__b37882fa__"